import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useLang } from "../contexts/LanguageContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const { t } = useLang();
  if (loading || user === null) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-zinc-500 font-mono text-xs uppercase tracking-[0.3em]">
        {t("loading")}
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
